module.exports = __webpack_public_path__ + "static/brand5-ff87fed0ee96384a592ac3d49afea528.png";